import type { LanguageCode } from '../types';

/**
 * Returns a CSS class name based on whether the current language is English.
 * Used to apply language-specific font/layout tweaks via CSS.
 */
export function getLangClass(languageCode: LanguageCode | null | undefined): string {
  return languageCode?.split('-')[0] === 'en' ? 'en' : '';
}
